import { ApiService as api } from "../Services/APIService";
import { TemplateService } from "../Services/TemplateService";
import { UtilService as util } from "../Services/UtilService";

export class WebFormModule {

    webFormObj = '';
    successText = '';
    mainElement = '';

    static async Init() {
        DEBUG && console.info('*--> WebForm Module Init');

        var elements = document.querySelectorAll('[data-component="webForm"]');

        elements.forEach(element => {

            this.mainElement = element;

            var webFormObj = element.getAttribute('data-form');
            this.webFormObj = webFormObj;

            var congregationId = element.getAttribute('data-congregationId');

            var title = element.getAttribute('data-title');

            var emailTemplate = element.getAttribute('data-template');
            var responseTemplate = element.getAttribute('data-responseTemplate');
            var userGroupID = element.getAttribute('data-userGroupID');
            var contactGUID = element.getAttribute('data-contactGUID');
            var openInModal = element.getAttribute('data-modal');

            var successText = element.getAttribute('data-successText');
            this.successText = successText;

            DEBUG && console.info('**************************************************');
            DEBUG && console.info(`Element ID:              ${element.id}`);
            DEBUG && console.info(`Web Form Name:           ${webFormObj}`);
            DEBUG && console.info(`Congregation ID:         ${congregationId}`);
            DEBUG && console.info(`Title:                   ${title}`);
            DEBUG && console.info(`Success Text:            ${successText}`);
            DEBUG && console.info(`Open In Modal:           ${openInModal}`);
            DEBUG && console.info('**************************************************');

            // =====================================
            // Current Forms
            // =====================================
            // webform-discipleship
            // webform-counseling

            if (openInModal == 'True') {
                this.InitWebFormModal(element, webFormObj, congregationId, title, emailTemplate, userGroupID, contactGUID, responseTemplate);
            } else {
                this.InitWebForm(element, webFormObj, congregationId, title, emailTemplate, userGroupID, contactGUID, responseTemplate);
            }
        });
    }

    static async InitWebForm(element, webFormObj, congregationId, title, emailTemplate, userGroupID, contactGUID, responseTemplate) {
        // getAuthenticated Data
        var currentUser = util.getUserObj();

        var data = { "congregationId": congregationId, "WebObjectType": `${webFormObj}`, "Title": title, "elementId": `${element.id}`, "emailTemplate": emailTemplate, "userGroupID": userGroupID, "contactGUID": `${contactGUID}`, "responseTemplate": `${responseTemplate}` };

        if (this.checkFormFromLocalStorage()) {
            element.innerHTML = `<div class="alert alert-info text-white">You recently filled this form out.  Under most circumstances you don't need to complete this form again.</div>`;
        }
        else {
            var content = await TemplateService.GetRenderedTemplate(`webForm-${webFormObj}`, data);
            element.innerHTML = content;

            // Wire Up Form Events
            var theForm = document.getElementById(`form${element.id}`);

            this.initFormEvents(theForm, this.submitForm);
        }
    }    

    static async InitWebFormModal(element, webFormObj, congregationId, title, emailTemplate, userGroupID, contactGUID, responseTemplate) {
        // getAuthenticated Data
        var currentUser = util.getUserObj();
        console.log("***---> Init WebFormModal: Get User")
        console.log(currentUser);

        var webFormModal = document.getElementById(`webformModal-${webFormObj}`);
        const modalContent = webFormModal.querySelector('.modal-content');

        var data = { "congregationId": congregationId, "WebObjectType": `${webFormObj}`, "Title": title, "elementId": `${element.id}`, "emailTemplate": emailTemplate, "userGroupID": userGroupID, "contactGUID": `${contactGUID}`, "responseTemplate": `${responseTemplate}`, "isModal": true };

        if (currentUser) {
            data.user = currentUser;
        }

        var content = await TemplateService.GetRenderedTemplate(`webForm-${webFormObj}`, data);
        modalContent.innerHTML = content;

        // Wire Up Form Events
        var theForm = document.getElementById(`form${element.id}`);

        this.initFormEvents(theForm, this.submitForm);

        // Wire Up Copy Link Button (if exists)
        var copyBtn = modalContent.querySelector('[data-btn="copyBtn"]');
        if (copyBtn) {        
            var copyUrl = util.createCopyUrl('openForm', webFormObj);

            copyBtn.addEventListener('click', () => {
                navigator.clipboard.writeText(copyUrl)
                    .then(function () {
                        // Show success message
                        util.showSuccessToast('Url copied to clipboard', 3000);
                    }).catch(function (error) {
                        // Show error message
                        util.showErrorToast('Something went wrong', 4000);
                    });
            });
        }

        const params = new URLSearchParams(window.location.search);
        const openForm = params.get('openForm'); // returns the value or null if not found

        if (openForm && openForm === webFormObj) {
            const webFormModal = document.getElementById(`webformModal-${webFormObj}`);
            const modalInstance = new bootstrap.Modal(webFormModal);
            modalInstance.show();
        }
    }    

    // This should now be a generalized function ready for Util Class or a Form Class
    static initFormEvents(formElement, submitFunction) {

        let self = this;

        var phoneFields = formElement.querySelectorAll(`[data-type="phone"]`);
        phoneFields.forEach(phone => {
            phone.addEventListener('input', function (event) {
                const input = event.target;
                const inputValue = input.value.replace(/\D/g, ''); // Remove non-numeric characters

                // Limit the length of inputValue to 10
                if (inputValue.length > 10) {
                    inputValue = inputValue.substring(0, 10);
                }
                
                if (inputValue.length <= 10) {
                    // Format as xxx-xxx-xxxx
                    input.value = inputValue.replace(/(\d{3})(\d{0,3})(\d{0,4})/, function (_, firstPart, secondPart, thirdPart) {
                        let formattedNumber = '';

                        if (firstPart) formattedNumber += `${firstPart}`;
                        if (secondPart) formattedNumber += `-${secondPart}`;
                        if (thirdPart) formattedNumber += `-${thirdPart}`;

                        return formattedNumber;
                    });
                }

            });
        });

        formElement.addEventListener('submit', function (event) {

            event.preventDefault();
            event.stopPropagation();

            // Check Validity
            if (!formElement.checkValidity()) {
                console.info("*** => Form INVALID");
            }
            else {
                // Get Captcha Token
                grecaptcha.ready(function () {
                    grecaptcha.execute('6LflXjcpAAAAALr80wVEcMlED_FNjFM4_UP3oa9J', { action: 'submit' })
                        .then(function (token) {
                            DEBUG && console.log("Captcha Output");
                            DEBUG && console.log(token);

                            // Submit Form via AJAX!!
                            submitFunction(token, formElement);
                        });
                });
            }

            formElement.classList.add('was-validated')
        }, false)
    }



    static submitForm(token, formElement) {
        DEBUG && console.log("***==> Send WebObject Data");

        var elementId = formElement.getAttribute("data-elementId");

        var mainElement = document.getElementById(elementId);
        var successText = mainElement.getAttribute('data-successText');
        var webObjType = mainElement.getAttribute('data-form');

        var emailTemplate = formElement.getAttribute('data-emailtemplate');
        var responseTemplate = formElement.getAttribute('data-responseTemplate');
        var userGroupID = formElement.getAttribute('data-userGroupID');
        var contactGUID = formElement.getAttribute('data-contactGUID');

        var formData = util.getFormDataObject(formElement);

        var submitData = {};
        submitData.WebObjectType = webObjType;
        submitData.Fields = formData;

        if (emailTemplate) {
            submitData.emailTemplate = parseInt(emailTemplate);
        }

        if (responseTemplate) {
            submitData.responseTemplate = parseInt(responseTemplate);
        }

        if (contactGUID) {
            submitData.contactGUID = contactGUID;
        }

        if (userGroupID) {
            submitData.userGroupID = parseInt(userGroupID);
        }
        

        DEBUG && console.log("****==> Form Payload:");
        DEBUG && console.log(submitData);

        api.postApiData(`WebObject/CreateWebObject`, submitData, token)
            .then((data) => {
                util.showSuccessToast(successText, 7000, true);
                mainElement.innerHTML = `<div class="alert alert-success text-bold">${successText}</div>`;


                var lsData = {};
                lsData.WebObjectType = webObjType;

                // Create a new Date object for the current date and time
                let currentDate = new Date();

                // Add 3 days to the current date
                currentDate.setDate(currentDate.getDate() + 3);

                lsData.Expires = currentDate.getTime();

                localStorage.setItem(`webObject:${webObjType}`, JSON.stringify(lsData));
            })
            .catch((error) => {
                console.error('Error:', error);
                util.showErrorToast('An error occured while sending your information.', 20000, true);
            });
    }



    static checkFormFromLocalStorage() {

        var formCheck = localStorage.getItem(`webObject:${this.webFormObj}`);

        if (formCheck !== null) {
            let currentDate = new Date();

            var formCheckObj = JSON.parse(formCheck);
            // Check for still Valid
            if (formCheckObj.Expires > currentDate.getTime()) {
                return true;
            }
            else {
                // Remove LocalStorage and Return
                localStorage.removeItem(`webObject:${this.webFormObj}`);
                return false;
            }
        }
        else {
            return false;
        }
    }
}